import React, { Component } from "react";
import "./navPanel.css";

export class NavPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, // hamburger toggle
        };
    }

    navLinkItems = [
        { title: this.props.i18n.Home, link: this.props.i18n.Home_Link },
        { title: this.props.i18n.About, link: this.props.i18n.About_Link },
        { title: this.props.i18n.Environment, link: this.props.i18n.Environment_Link },
        { title: this.props.i18n.Regulations, link: this.props.i18n.Regulations_Link },
        { title: this.props.i18n.Education, link: this.props.i18n.Education_Link },
        { title: this.props.i18n.Health, link: this.props.i18n.Health_Link },
        { title: this.props.i18n.Events, link: this.props.i18n.Events_Link },
        { title: this.props.i18n.Research, link: this.props.i18n.Research_Link },
        { title: this.props.i18n.Weather, link: this.props.i18n.Weather_Link },
        { title: this.props.i18n.News_Archives, link: this.props.i18n.News_Archives_Link },
        { title: this.props.i18n.Radio, link: this.props.i18n.Radio_Link },
        { title: this.props.i18n.Prescribed_Burning, link: this.props.i18n.Prescribed_Burning_Link },
        { title: this.props.i18n.Woody_Encroachment, link: this.props.i18n.Woody_Encroachment_Link },
        { title: this.props.i18n.Burn_Info, link: this.props.i18n.Burn_Info_Link }
    ];

    toggleMenu = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        return (
            <div className="nav-container">
                <button className="hamburger" onClick={this.toggleMenu}>
                    ☰
                </button>

                <div className={`nav-panel ${this.state.open ? "open" : ""}`}>
                    {this.navLinkItems.map((item, index) => (
                        <div
                            key={index}
                            className="nav-link"
                            onClick={() => window.open(item.link, "_self")}
                        >
                            {item.title}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default NavPanel;